import { isNil } from "lodash";
import type { RocketchatResponseHandler } from "../RocketchatResponseHandler";
import { getChannel } from "../channel/api/getChannel";
import { store } from "../redux/store";
import { SocketClient } from "../socket/socketClient";
import { renewChannelEventThunk } from "./chatEventThunk";

export const handleRenewChannelEventHandler: RocketchatResponseHandler =
  async ({ response }) => {
    const renewChannel = response?.renew_channel;

    if (isNil(renewChannel)) {
      throw new Error("renewChannelEventHandler: renewChannel is nil");
    }

    const socket = SocketClient.getInstance().getWebSocket();

    const { channel, users, lastChatMessage } = await getChannel(
      {
        channelId: renewChannel.channel_id,
      },
      socket,
    );

    store.dispatch(
      renewChannelEventThunk({
        channel,
        users,
        lastChatMessage,
      }),
    );
  };
